import { render, staticRenderFns } from "./Rovers.vue?vue&type=template&id=fb3b3e32&scoped=true&"
import script from "./Rovers.vue?vue&type=script&lang=js&"
export * from "./Rovers.vue?vue&type=script&lang=js&"
import style0 from "./Rovers.vue?vue&type=style&index=0&id=fb3b3e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb3b3e32",
  null
  
)

export default component.exports